import React from 'react';
import { ItemCallback } from 'react-grid-layout';
import { some } from 'lodash/fp';
import { Section } from '../../../../server-types';
import { useForceUpdate } from '../../../../utils';
import Query from '../../../../graphql/Query';
import { CREATE_PLACE, GET_SECTIONS, UPDATE_PLACE_COORDINATES } from '../../graphql';
import { useMutation, useSilentMutation } from '../../../../graphql/hooks';
import { GRID_COLUMNS } from './constants';
import { ActiveSectionPayload, TableMapPlace } from './types';
import TableMap from './TableMap';

export interface TableMapQueryResult {
    sections: Array<Section>;
}

const Tables = () => {
    const [updatePlace] = useSilentMutation(UPDATE_PLACE_COORDINATES);
    const [createPlace] = useMutation(CREATE_PLACE, { refetchQueries: [{ query: GET_SECTIONS }] });
    const forceUpdate = useForceUpdate();

    const onDragStop: ItemCallback = async (layout, oldItem, newItem) => {
        try {
            if (oldItem.x !== newItem.x || oldItem.y !== newItem.y ){
                await updatePlace({ variables: { ...newItem, id: newItem.i } });
            }
        } catch(e) {
            // rerendering with old value - solve fetch from cache for it to work
            forceUpdate();
        }
    };

    const onCreatePlace = (places: Array<TableMapPlace>) => async (activeSection: ActiveSectionPayload ) => {
        let coordinateX = 0;
        let coordinateY = 0;

        // This is kinds slow. We should use hashmap with x and y as keys.
        // eslint-disable-next-line
        while (some(({ x, y }) =>
            (x === coordinateX && y === coordinateY) ||
            // eslint-disable-next-line
            (x === coordinateX + 1 && y === coordinateY) ||
            // eslint-disable-next-line
            (x === coordinateX - 1 && y === coordinateY ||
            (x === coordinateX && y === coordinateY + 1) ||
            (x === coordinateX && y === coordinateY - 1) ||
            (x === coordinateX + 1 && y === coordinateY + 1) ||
            (x === coordinateX + 1 && y === coordinateY - 1) ||
            (x === coordinateX - 1 && y === coordinateY + 1) ||
            (x === coordinateX - 1 && y === coordinateY -1)
            ), places)) {

            if (coordinateX !== GRID_COLUMNS - 1) {
                coordinateX += 1;
            } else {
                coordinateX = 0;
                coordinateY += 1;
            }

        }

        const variables = {
            coordinateX,
            coordinateY,
            sectionId: activeSection.id,
            name: `${activeSection.name} ${places.length + 1}`, // this should be taken from floor
        };

        try {
            await createPlace({ variables });
        } catch(e) {
            // Nothing we can do
        }
    };
    return (
        <Query<TableMapQueryResult> query={GET_SECTIONS} fetchPolicy='cache-first'>
            {({ data }) => {
                const { sections } = data;
                return (
                    <TableMap sections={sections} onDragStop={onDragStop} onCreatePlace={onCreatePlace} />
                );
            }}
        </Query>
    );

};

export default Tables;
